const STORAGE_KEY = 'attribution';

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

const META_KEYS = ['fbclid', 'fbc', 'fbp', 'leadgen_id'];

const ALL_KEYS = [...UTM_KEYS, ...META_KEYS];

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function readStored() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function writeStored(data) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function mergeAttribution(updates) {
  const stored = readStored();
  let changed = false;

  ALL_KEYS.forEach((key) => {
    const value = updates[key];
    if (value && !stored[key]) {
      stored[key] = value;
      changed = true;
    }
  });

  if (changed) {
    writeStored(stored);
  }

  return stored;
}

function buildFbc(fbclid) {
  return `fb.1.${Date.now()}.${fbclid}`;
}

function collectFromSearchParams() {
  const params = new URLSearchParams(window.location.search);
  const updates = {};

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      updates[key] = value;
    }
  });

  const fbclid = params.get('fbclid');
  if (fbclid) {
    updates.fbclid = fbclid;
    updates.fbc = buildFbc(fbclid);
  }

  const leadgenId = params.get('leadgen_id');
  if (leadgenId) {
    updates.leadgen_id = leadgenId;
  }

  const fbcFromCookie = getCookie('_fbc');
  if (fbcFromCookie) {
    updates.fbc = fbcFromCookie;
  }

  return updates;
}

function collectFbpFromCookie() {
  const fbp = getCookie('_fbp');
  return fbp ? { fbp } : {};
}

export function captureAttribution() {
  mergeAttribution(collectFromSearchParams());
  mergeAttribution(collectFbpFromCookie());
}

export function refreshAttributionFromCookies() {
  mergeAttribution(collectFbpFromCookie());
  const fbcFromCookie = getCookie('_fbc');
  if (fbcFromCookie) {
    mergeAttribution({ fbc: fbcFromCookie });
  }
}

export function getAttributionPayload() {
  refreshAttributionFromCookies();

  const stored = readStored();
  const payload = {};

  ALL_KEYS.forEach((key) => {
    if (stored[key]) {
      payload[key] = stored[key];
    }
  });

  return payload;
}

export function initAttribution() {
  captureAttribution();

  window.setTimeout(refreshAttributionFromCookies, 500);
  window.setTimeout(refreshAttributionFromCookies, 1500);
}
